import { defineAsyncComponent } from 'vue'
import StatesAccordions from './../components/participating_states/StatesAccordions.vue'
import { createApp } from 'vue';

if ( document.getElementById('states_map') ) {
    const app = createApp();
    app.component('StatesMap', defineAsyncComponent(() =>
        import('./../components/participating_states/StatesMap.vue')
    ));
    app.mount('#states_map');
}

if ( document.getElementById('states_accordions') ) {
    const app = createApp({
        components: {
            StatesAccordions
        }
    });
    app.mount('#states_accordions');
}